<template>
  <v-layout row>
    <v-col cols="12">
      <v-expansion-panels>
        <v-expansion-panel
          v-for="purchaseItem in purchaseItems"
          :key="purchaseItem.position"
        >
          <v-expansion-panel-header disable-icon-rotate>
            {{ purchaseItem.position }} - {{ purchaseItem.positionItem }}
            <div class="d-inline-flex justify-end pr-2">
              {{ purchaseItem.purchaseItems.length }} Einträge
            </div>
            <template #actions>
              <v-icon
                v-if="purchaseItem.isError"
                color="error"
              >
                mdi-alert-circle
              </v-icon>
              <v-icon v-else color="teal">
                mdi-check
              </v-icon>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content v-if="purchaseItem.purchaseItems.length > 0">
            <v-row
              v-for="pPurchaseItem in purchaseItem.purchaseItems"
              :key="pPurchaseItem.id"
            >
              <v-col>
                DEBUG ID {{ pPurchaseItem.pivot_id }}
              </v-col>
              <v-col>
                {{ pPurchaseItem.name }}
              </v-col>
              <v-col v-if="pPurchaseItem.present">
                Seriennummer: {{ pPurchaseItem.serial }} in Vertrag gebucht.
                EK: {{ pPurchaseItem.price_purchasing }} €
              </v-col>
              <v-col v-else-if="pPurchaseItem.fromWarehouse">
                Seriennummer: {{ pPurchaseItem.serial }}, aus Lager: {{ pPurchaseItem.location.number }} - {{ pPurchaseItem.location.name }}
              </v-col>
              <v-col v-else>
                muss bestellt werden!
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-col>
    <v-col cols="4">
      <v-dialog v-model="addPurchaseItemsDialog" max-width="1200px">
        <template #activator="{ on }">
          <v-btn color="primary" dark v-on="on">
            Artikel erfassen
          </v-btn>
        </template>
        <v-card>
          <v-card-title class="headline">
            Artikel erfassen
          </v-card-title>

          <v-card-text
            v-for="(itemFromWarehouse, index) in assignPurchaseItemsForm.items"
            :key="`missingPurchaseItems_${index}`"
          >
            <v-row>
              <v-col cols="4" class="mt-6 text-body-1">
                Artikel: {{ itemFromWarehouse.name }}
              </v-col>
              <v-col cols="4" class="mt-6 text-body-1">
                Warehouse: {{ itemFromWarehouse.warehouse }}
              </v-col>
              <v-col cols="4">
                <v-text-field
                  v-model="itemFromWarehouse.serial"
                  label="Seriennummer"
                  :placeholder="itemFromWarehouse.suggestedSerial"
                  persistent-placeholder
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="error"
              text
              @click.native="addPurchaseItemsDialog = false"
            >
              Abbrechen
            </v-btn>
            <v-btn
              color="primary"
              @click.native="submit"
            >
              Speichern
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
    <v-col cols="4">
      <download-csv
        :data="itemsFromWarehouse"
        :name="`${contract.number}_Lagerartikel.csv`"
      >
        <v-btn color="success">
          Lagerartikel CSV
        </v-btn>
      </download-csv>
    </v-col>
    <v-col cols="4">
      <download-csv
        :data="itemsToOrder"
        :name="`${contract.number}_Bestellartikel.csv`"
      >
        <v-btn color="success">
          Bestellartikel CSV
        </v-btn>
      </download-csv>
    </v-col>
    <v-col cols="4">
      <v-btn color="success" @click="reservePurchaseItemStocks">
        Reserviere Lagerartikel
      </v-btn>
    </v-col>
  </v-layout>
</template>

<script>
import JsonCSV from 'vue-json-csv'
export default {
   components: {
      downloadCsv: JsonCSV,
   },
   props: {
      purchaseItems: {
         type: Array,
         required: true,
      },
      contract: {
         type: Object,
         required: true
      }
   },
   data () {
      return {
         addPurchaseItemsDialog: false,
         assignPurchaseItemsForm: this.$inertia.form({
            items: null
         })
      }
   },
   computed: {
      itemsFromWarehouse () {
         return this.purchaseItems
            .reduce((returnArr, purchaseItem, index) => {
               const purchaseItems = purchaseItem.purchaseItems.filter(
                  (elem) => elem.fromWarehouse
               )
               purchaseItems.forEach((elem) => {
                  returnArr.push({
                     id: elem.id,
                     purchase_item_stock_id: elem.purchase_item_stock_id,
                     position_purchase_item: elem.position_purchase_item,
                     position: elem.position,
                     name: elem.name,
                     warehouse: `${elem.location.number} - ${elem.location.name}`,
                     suggestedSerial: elem.serial,
                     serial: null
                  })
               })
               return returnArr
            }, [])
            .filter((elem) => elem !== undefined)
            .sort(function (a, b) {
               const nameA = a.name.toUpperCase() // Groß-/Kleinschreibung ignorieren
               const nameB = b.name.toUpperCase() // Groß-/Kleinschreibung ignorieren
               if (nameA < nameB) {
                  return -1
               }
               if (nameA > nameB) {
                  return 1
               }

               // Namen müssen gleich sein
               return 0
            })
      },
      itemsToOrder () {
         return this.purchaseItems
            .reduce((returnArr, purchaseItem, index) => {
               const purchaseItems = purchaseItem.purchaseItems.filter(
                  (elem) => elem.toOrder
               )
               purchaseItems.forEach((elem) => {
                  returnArr.push({
                     id: elem.id,
                     name: elem.name,
                     supplier: elem.supplier
                  })
               })
               return returnArr
            }, [])
            .filter((elem) => elem !== undefined)
            .sort(function (a, b) {
               const nameA = a.name.toUpperCase() // Groß-/Kleinschreibung ignorieren
               const nameB = b.name.toUpperCase() // Groß-/Kleinschreibung ignorieren
               if (nameA < nameB) {
                  return -1
               }
               if (nameA > nameB) {
                  return 1
               }

               // Namen müssen gleich sein
               return 0
            })
      }
   },
   created () {
      this.assignPurchaseItemsForm.items = this.itemsFromWarehouse
   },
   methods: {
      submit () {
         this.assignPurchaseItemsForm.post(this.route('contract.assignPurchaseItemStocks', this.contract.id))
      },
      reservePurchaseItemStocks () {
         this.$inertia.post(this.route('contract.reservePurchaseItemStocks', this.contract.id))
      }
   }
}
</script>

<style>
</style>
